<template>
  <div>
    <div style="max-height: 400px">
      <div class="mb-3">
        <el-radio v-model="radio" label="all">
          <span style="color: #000;">Tất cả nhân viên</span>
        </el-radio>
      </div>
      <div class="mb-2">
        <el-radio v-model="radio" label="custom">
          <span style="color: #000;" aria-disabled="true">Tuỳ chọn nhân viên</span>
        </el-radio>
        <div class="ml-8 mt-2" v-if="radio === 'custom'">
          <div
            v-loading="loading"
            class="mt-3"
            element-loading-spinner="el-icon-loading"
          ></div>
          <div class="flex-column d-flex overflow-auto " style="max-height: 300px">
            <el-checkbox
              v-for="(item ,index) in employees"
              :key="index"
              v-model="item.isCheck"
              @change="onClickCheckbox(item, index)"
              size="medium"
            >
              <div class="mt-1" style="color: #606266;">{{ item.username }}</div>
            </el-checkbox>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex mt-4" style="justify-content: flex-end;">
      <el-button class="btn-cancel" type="default" @click="closeDialog()">Huỷ</el-button>
      <el-button class="btn-save" type="primary" @click="save()">Lưu</el-button>
    </div>
  </div>
</template>
<style scoped>
.btn-cancel, .btn-save {
  width: 100px;
}

.btn-cancel {
  background-color: #F4F5F9;
  color: #202125;
  border: none;
}
</style>
<script>


import { HTTP } from "../lib/http-common";

export default {
  props: {
    accountId: { type: String },
    closeDialog: {
      type: Function,
      default: () => {
      }
    }
  },
  data() {
    return {
      employees: [],
      employeeShops: [],
      radio: "all",
      loading: false,
      allEmployee: false
    };
  },
  watch: {
    accountId: async function() {
      this.loading = true;
      await this.findByShopUserId();
      await this.fetchEmployeeList();
      this.loading = false;
    }
  },
  methods: {
    onClickCheckbox(item, index) {
      if (item.isCheck) this.employeeShops.push(this.employees[index].username);
      else this.employeeShops.splice(this.employeeShops.indexOf(item.username), 1);
    },
    async save() {
      let request = {
        allEmployee: this.radio === "all",
        accountId: this.accountId,
        employeeList: this.radio !== "all" ? this.employeeShops : this.employees.map(s => s.username)
      };
      HTTP.post("/api/user/employee/authorization", request)
        .then((res) => {
          if (res.status === "success") {
            this.alert("success", "Phân quyền thành công cho nhân viên.");
          }
          this.closeDialog();
        })
        .catch(() => {
          this.alert("error", "Có lỗi xảy ra.");
        });
    },
    async findByShopUserId() {
      HTTP.get("/api/user/employee/byAccount", { params: { accountId: this.accountId } }).then((res) => {
        if (res.status === "success") {
          this.employeeShops = res.data.employeeList.map(e => e.username);
          this.allEmployee = res.data.allEmployee;
          this.radio = this.allEmployee ? "all" : "custom";
        }
      });
    },


    async fetchEmployeeList() {
      HTTP.get("/api/user/employee").then((response) => {
        if (response.status === "success") {
          let employeeList = response.data.filter(s=>s.type!=="ADMIN").map(e => e.username);
          employeeList.forEach((em) => {
            this.employees.push({
              username: em,
              isCheck: this.employeeShops.length === 0 ? false : this.employeeShops.includes(em)
            });
          });
        }
      });
    }
  },
  async created() {
    this.loading = true;
    await this.findByShopUserId();
    await this.fetchEmployeeList();
    this.loading = false;
  }
};
</script>
